module.exports = __webpack_public_path__ + "resources/img/img_magic_sso_en.75787d813f66cb6bdb19b64125a81763.png";